<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar entrada
            <router-link :to="{ name: 'Entrada', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value.sync="$v.date.$model"
                  :isValid="checkIfValid('date')"
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>


            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Almacén:</label>
                <v-select
                  v-model="almacen"
                  :options="almacenes"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un almacén"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>


            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="folio_proveedor"
                  label="Folio proveedor"
                  placeholder="Folio proveedor..."
                  type="text"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Proveedores:</label>
                <v-select
                  v-model="proveedor"
                  :options="proveedores"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un proveedor"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CTextarea 
                  :value.sync="comentarios"
                  :label="`Comentarios: `"
                  placeholder="Comentarios..." 
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>

            <hr class="my-4 line" />
            <CRow class="mb-3">
              <CCol lg="3" xl="3">
                <v-select
                  v-model="producto"
                  :options="productos"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  @input="getUnidad()"
                  placeholder="Producto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
              <CCol lg="3" xl="2">
                <CInput v-model="unidad" readonly placeholder="Unidad..." type="text" />
              </CCol>
              <CCol lg="3" xl="3">
                <CInput
                  :value.sync="$v.cantidad.$model"
                  :isValid="checkIfValid('cantidad')"
                  placeholder="Cantidad"
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
              <CCol lg="3" xl="3">
                <CInput
                  :value.sync="$v.costo.$model"
                  :isValid="checkIfValid('costo')"
                  prepend="$"
                  placeholder="Costo unitario"
                  type="number"
                  invalidFeedback="Campo requerido"
                ></CInput>
              </CCol>
              <CCol xl="1">
                <CButton @click="addProducto()" class="float-right" color="success">Agregar</CButton>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="detalles"
                  :fields="fieldsSecondModal"
                >
                  <template #producto_id="{item}">
                    <td class="py-2">{{ getProducto(item.producto_id) }}</td>
                  </template>
                  <template #unidad="{item}">
                    <td class="py-2">{{ getProdUnidad(item.producto_id) }}</td>
                  </template>
                  <template #importe="{item}">
                    <td class="py-2">${{ (item.cantidad * item.costo_unitario).toFixed(2) }}</td>
                  </template>
                  <template #cancel="{ index}">
                    <td class="py-2">
                      <CButton color="danger" square size="sm" @click="deleteDetalle(index)">Borrar</CButton>
                    </td>
                  </template>
                  <template #under-table>
                    <h5 class="text-right padding-left-custom">
                      Total:
                      <span class="ml-3">${{ totalDetails }}</span>
                    </h5>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Entrada' , params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>
            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addEntrada()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Entrada"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
        size="sm"
        title="Entrada"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="successModal = false"  color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

const fieldsSecondModal = [
  { key: "producto_id", label: "Productos", _style: "width:20%" },
  { key: "unidad", label: "Unidad", _style: "width:20%" },
  { key: "cantidad", _style: "width:20%" },
  { key: "costo_unitario", _style: "width:20%" },
  { key: "importe", _style: "width:20%" },

  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "NuevoEntrada",

  components: {
    vSelect
  },

  data() {
    return {
      detalles: [],
      config: this.$route.params.config,
      date: null,
      almacen: "",
      folio_proveedor: "",
      proveedor: "",
      almacenes: [],
      unidad: "Unidad",
      fieldsSecondModal,
      productos: [],
      producto: null,
      productosAll: [],
      proveedores: [],
      cantidad: null,
      warningModal: false,
      successModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      costo: null,
      comentarios: '',
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    cantidad: {
      required,
      notNegative: (value) => value >= 0
    },
    costo: {
      required,
      notNegative: (value) => value >= 0
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    isValidCantidad() {
      return !this.$v.cantidad.$invalid;
    },
    isValidCosto() {
      return !this.$v.cantidad.$invalid;
    },
    totalDetails() {
      if (this.detalles.length) {
        return this.detalles
          .reduce(
            (acount, detail) =>
              Number(acount) +
              Number(detail.cantidad) * Number(detail.costo_unitario),
            0
          )
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0.00";
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "almacenes",
        filter: {
          wherein: [
            {
              field: "payload->ubicacion_id",
              value: [this.ubicacionRaizValue]
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "productos",
        filter: {
          where: [
            {
              field: "payload->unidad",
              value: "",
              operator: "!="
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "proveedores"
      }),
    ];

    Promise.all(ubi)
      .then(([almacenes, productos, proveedores]) => {
        this.almacenes = almacenes.data.map(almacen => {
          return { value: almacen.id, label: almacen.payload.nombre };
        });
        this.proveedores = proveedores.data.map(proveedor => {
          return { value: proveedor.id, label: proveedor.payload.nombre };
        });
        this.productos = productos.data.map(producto => {
          return { value: producto.id, label: producto.payload.nombre };
        });
        this.productosAll = productos.data;
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    getProducto(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.nombre;
    },
    getProdUnidad(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.unidad;
    },
    addProducto() {
      this.validateProducto();

      if (this.producto && this.cantidad && this.costo) {
        // this.detalles.push(this.nombreEtapa);
        this.detalles.push({
          producto_id: this.producto.value,
          cantidad: Number(this.cantidad),
          costo_unitario: Number(this.costo)
        });
        this.resetProducto();
      }
    },
    getUnidad() {
      if (this.producto) {
        const productoActual = this.productosAll.filter(
          producto => producto.id == this.producto.value
        );

        this.unidad = productoActual[0].payload.unidad;
      } else {
        this.unidad = "Unidad";
      }
    },
    deleteDetalle(index) {
      if (index !== -1) {
        this.detalles.splice(index, 1);
      }
    },
    async addEntrada() {
      this.validateEntrada();
      this.fetching = true
      this.isLoading = true;
      await (new Promise((res,)=>{
        const iter = setInterval(()=>{
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
          debugger
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }

      if (this.isValidDate) {
        if (!this.almacen) {
          this.error = "El campo almacén es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        let newDate = moment(this.date, "YYYY-MM-DD HH:mm:ss");
        // console.log(this.date);
        // console.log(newDate.format("YYYY-MM-DD HH:mm:ss"));
        // let newDate = new Date(this.date);

        this.$store
          .dispatch("customDocumentoAddHTTP", {
            schema: "entradas",
            payload: {
              encabezado: {
                fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                almacen_id: this.almacen?.value || "",
                proveedor_id: this.proveedor?.value || "N/A",
                folio_proveedor: this.folio_proveedor||'',
                ubicacion_raiz_id: this.ubicacionRaiz
                  ? this.ubicacionRaiz.value
                  : null,
                comentarios: this.comentarios || '',
              },
              anexos: this.medias,
              detalles: this.detalles,
            }
          })
          .then(() => {
            // console.log(res.data);
            this.currentAlertCounter = 6;

            // this.$router.push({ name: "Entrada" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.isLoading = false;
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateEntrada() {
      this.$v.date.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    validateProducto() {
      // this.$v.producto.$touch();
      this.$v.cantidad.$touch();
      this.$v.costo.$touch();
    },
    resetProducto() {
      this.cantidad = null;
      this.unidad = "Unidad";
      this.producto = null;
      this.costo = null;
      this.$v.cantidad.$reset();
      this.$v.costo.$reset();
    },
    updateCombos() {
      this.isLoadingPage = true;
      this.$store;

      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaizValue]
              }
            ]
          }
        })
      ];

      Promise.all(ubi)
        .then(([almacenes]) => {
          this.almacenes = almacenes.data.map(almacen => {
            return { value: almacen.id, label: almacen.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
